import { BottomNavigation, BottomNavigationAction } from '@material-ui/core'
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon'
import CalendarMonthOutlineIcon from 'mdi-react/CalendarMonthOutlineIcon'
import HomeCityOutlineIcon from 'mdi-react/HomeCityOutlineIcon'
import ChartTimelineVariantIcon from 'mdi-react/ChartTimelineVariantIcon'
import MessageIcon from 'mdi-react/MessageIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { MuiClasses } from '../../types'

interface ApartmentBottomNavProps {
  basePath: string
  pathname: string
  onNavigate: (path: string) => void
  classes: MuiClasses
  isContractRoute: boolean
  hasStatistics: boolean
}

type MobileNavItem = {
  id: string
  label: string
  icon: FC<any>
}

const apartmentNavItems: MobileNavItem[] = [
  {
    id: '/overview',
    label: 'navigation.apartments',
    icon: HomeCityOutlineIcon
  },
  {
    id: '/statistic',
    label: 'navigation.statistics',
    icon: ChartTimelineVariantIcon
  },
  {
    id: '/applications',
    label: 'navigation.applicants',
    icon: AccountGroupOutlineIcon
  },
  {
    id: '/messages',
    label: 'navigation.messages',
    icon: MessageIcon
  },
  {
    id: '/showings/overview',
    label: 'navigation.calendar',
    icon: CalendarMonthOutlineIcon
  }
]

const getActiveValue = (pathname: string, isContractRoute: boolean) => {
  if (isContractRoute) {
    return '/applications'
  }
  if (pathname.includes('/applications')) {
    return '/applications'
  }
  if (pathname.includes('/messages')) {
    return '/messages'
  }
  if (pathname.includes('/showings')) {
    return '/showings/overview'
  }
  if (pathname.includes('/statistic')) {
    return '/statistic'
  }
  if (pathname.includes('/overview')) {
    return '/overview'
  }
  return '/overview'
}

const ApartmentBottomNav: FC<ApartmentBottomNavProps> = ({
  basePath,
  pathname,
  onNavigate,
  classes,
  isContractRoute,
  hasStatistics
}) => {
  const { t } = useTranslation()
  let currentValue = getActiveValue(pathname, isContractRoute)
  if (!hasStatistics && currentValue === '/statistic') {
    currentValue = '/overview'
  }
  const filteredNavItems = hasStatistics
    ? apartmentNavItems
    : apartmentNavItems.filter((item) => item.id !== '/statistic')

  return (
    <div className={classes.mobileBottomNavWrapper}>
      <BottomNavigation
        value={currentValue}
        onChange={(_event, value) => {
          const destination = `${basePath}${value}`
          if (pathname !== destination) {
            onNavigate(destination)
            window.scrollTo(0, 0)
          }
        }}
        className={classes.mobileBottomNav}
        showLabels
      >
        {filteredNavItems.map(({ id, label, icon: Icon }) => (
          <BottomNavigationAction
            key={id}
            value={id}
            label={t(label)}
            icon={<Icon className={classes.mobileBottomNavIcon} />}
            classes={{
              root: classes.mobileBottomNavActionRoot,
              selected: classes.mobileBottomNavActionSelected,
              label: classes.mobileBottomNavActionLabel
            }}
          />
        ))}
      </BottomNavigation>
    </div>
  )
}

export default ApartmentBottomNav
